"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function normalizeName(tagName) {
    if (tagName[0] === tagName[0].toUpperCase()) {
        return tagName + '-component';
    }
    return tagName;
}
exports.default = normalizeName;
//# sourceMappingURL=normalizeName.js.map